angular.module('leave')
    .factory('LeaveType', function ($resource) {
        return $resource('/crm/api/leave-type/:id', {}, {
            list: {method: 'GET', isArray: false},
            get: {method: 'GET'},
            update: {method: 'PUT', params: {id: "@id"}},
            remove: {method: 'DELETE'},
            autocomplete: {method: 'GET', isArray: true, url: '/crm/api/leave-type/autocomplete'}
        })
    })
    .directive('leaveTypePicker', function ($translate, LeaveType) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                required: "=",
                modelType: '=?',
                activeOnly: "=?",
                onChange: "&"
            },
            templateUrl: "app/leave/type/picker.html",
            link: function (scope, $element, $attrs, ngModelCtrl) {
                scope.executeOnChange = scope.onChange || angular.noop
                scope.modelTypeR = scope.modelType || "object"
                scope.activeOnly = scope.activeOnly != null? scope.activeOnly : true

                scope.refreshData = search => {
                    let selectedId = ngModelCtrl.$modelValue ? ngModelCtrl.$modelValue.id : null
                    LeaveType.autocomplete({search: search, size: 1000, activeOnly: scope.activeOnly, selectedId: selectedId}).$promise
                        .then(items => scope.items = items);
                }

                ngModelCtrl.$render = () => scope.selected = ngModelCtrl.$viewValue
                ngModelCtrl.$formatters.push(modelValue => modelValue)
                ngModelCtrl.$parsers.push(viewValue => scope.modelTypeR === "id" ? viewValue.id : viewValue);

                scope.onSelectionChanged = ($item, $model) => {
                    ngModelCtrl.$setViewValue($item)
                    ngModelCtrl.$validate()
                    ngModelCtrl.$render()
                    if (angular.isFunction(scope.executeOnChange())) {
                        scope.executeOnChange()($item)
                    }
                }

                scope.groupByFn = item => {
                    if(item.category == null) {
                        return "-"
                    }
                    return $translate.instant("leave-type.category." + item.category)
                };
            }
        }
    })
    .service('LeaveTypeService', function ($rootScope, toastr, modals, LeaveType) {
        this.categories = () => ['DAY_OFF', 'SICK', 'SPECIAL', 'COMPENSATORY_DAY_OFF']
        this.edit = id => {
            return LeaveType.get({id: id}, entity => editModal(entity))
        }
        this.addModal = () => {
            let entity = {
                id: null
            }
            return editModal(entity)
        };
        this.remove = item => {
            return modals.confirmDelete(item.name, () => LeaveType.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast('leave-type.updated')));
        }

        function editModal(entity) {
            return modals.open('app/leave/type/edit-modal.html', 'LeaveTypeDialogController', entity, {size: "sm"}, "$ctrl");
        }
    })
    .controller('LeaveTypeDialogController', function ($scope, $rootScope, $uibModalInstance, data, toastr, LeaveType, LeaveTypeService) {
        this.$onInit = () => {
            this.item = data
            this.categories = LeaveTypeService.categories()
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = LeaveType.update(this.item).$promise
            } else {
                promise = LeaveType.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast('leave-type.updated')
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        };
    })
    .component('leaveTypeList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/leave/type/list.html',
        controller: function ($scope, $httpParamSerializer, $state, $stateParams, LeaveTypeService, InvoiceService, Principal) {
            this.reset = () => this.filters = {}
            this.InvoiceService = InvoiceService
            this.LeaveTypeService = LeaveTypeService

            this.$onInit = () => {
                this.canEdit = Principal.hasAnyAuthority(['ROLE_LEAVE_MANAGER'])
                this.categories = () => LeaveTypeService.categories()
            }

            this.getExportUrl = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/leave-type-batch/export?" + $httpParamSerializer(paramsAll)
            }

            $scope.$on('leave-type.updated', () => $state.reload())
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('leaveTypeList', {
            parent: 'app',
            url: '/leave-type?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_LEAVE_MANAGER']
            },
            views: {
                'content@': 'leaveTypeList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (LeaveType, $stateParams) => LeaveType.list($stateParams).$promise
            }
        })
    })
